import React from "react";
import naodImg from "../assets/img/yisa profile.jpg";
import styles from "./Team.module.css";

const teamMembers = [
  {
    name: "Dr.Sebsebe",
    role: "CEO, YOD Business Solution",
    img: null,
    desc: "Dr.Sebsebe is the CEO of YOD business solution, a highly skilled professional with years of experience in website design, SEO, digital marketing, software and mobile app development. He is also an experienced project manager with a track record of delivering projects on time and within budget.",
    linkedin: "https://www.linkedin.com/in/naodyeshiwas/",
    instagram: "https://www.instagram.com/naodyeshiwas/"
  }
];

const Team = () => {
  return (
    <div className="container-fluid team py-5 bg-white">
      <div className="container py-5">
        <div className="text-center mb-5" data-aos="fade-up">
          <h5 className="sub-title" style={{ color: "#A71717" }}>OUR Founders</h5>
          <h1 className="display-5 mb-3" style={{ color: "#A71717" }}>Meet The Founder & CEO</h1>
        </div>
        <div className="row justify-content-center">
          {teamMembers.map((member, i) => (
            <div className="col-lg-6 col-md-8" key={i}>
              <div className={styles["team-card"]}>
                <img src={member.img} alt={member.name} className={styles["team-img"]} />
                <div className={styles["team-name"]}>{member.name}</div>
                <div className={styles["team-role"]}>{member.role}</div>
                <div className={styles["team-desc"]}>{member.desc}</div>
                <div className={styles["team-social"]}>
                  <a href={member.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                    <i className="fab fa-instagram"></i>
                  </a>
                  <a href={member.linkedin} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                    <i className="fab fa-linkedin-in"></i>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Team;
